import React from 'react';
import {Trans} from 'react-i18next';
import Select from 'react-select';
import {deviceOptions} from '../../config/utils/optionsUtils';
import storeUtils from '../../../../../utils/storeUtils';
import _get from 'lodash/get';
import {Field, FieldArray} from 'formik';
import _isEmpty from 'lodash/isEmpty';
import DeviceImage from '../../landingpage/deviceImage';
import {useSelector} from 'react-redux';
import smbUtils from '../../../../../utils/smbUtils';

export default function GenericLayoutSettings({
  formikProps,
  device,
  setDevice,
}) {
  const auth = useSelector(state => state.components.auth.accountSummary);
  const {customerId} = smbUtils.customerInfo(auth);
  return (
    <>
      <h5>
        <Trans i18nKey="p.s.uiconfiguration.survey.background.image">
          Survey Background Image
        </Trans>
        <div
          className="kt-margin-t-10"
          style={{
            backgroundColor: '#e1e1ef',
            height: '1px',
          }}
        />
      </h5>
      <div className="form-group row">
        <label className="col-2 col-form-label text-right">
          <Trans i18nKey="p.s.uiconfiguration.landingpage.device">Device</Trans>
        </label>
        <div className="col-5">
          <Select
            options={deviceOptions}
            onChange={o => {
              storeUtils.setUiConfigSettingDevice(customerId, _get(o, 'value'));
              setDevice(o);
            }}
            value={device}
            isSearchable={false}
            isClearable={false}
            placeholder={
              <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
            }
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-2 col-form-label text-right">
          <Trans i18nKey="p.e.listproduct.product.modal.sku.image">Image</Trans>
        </label>
        <div className="col-4">
          {device.value === 'pad' && (
            <FieldArray name={`mainImage[0].imagesUrl`}>
              {arrayHelpers => (
                <div style={{display: 'flex'}}>
                  {!_isEmpty(
                    _get(formikProps.values, `mainImage[0].imagesUrl`)
                  ) &&
                    _get(formikProps.values, `mainImage[0].imagesUrl`)
                      .filter((_, index) => index === 1)
                      .map((s, index) => (
                        <div
                          key={`padbanner${index}`}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <Field
                            name={`mainImage[0].imagesUrl[${index}]`}
                            scaleImage={true}
                            clearFormFields={[
                              `mainImage[0].imagesUrl[${index}].image`,
                              `mainImage[0].imagesUrl[${index}].url`,
                            ]}
                            component={DeviceImage}
                            width={1536}
                            height={1468}
                            maxWidth={300}
                            maxHeight={(300 / 1536) * 1468}
                            values={formikProps.values}
                          />
                        </div>
                      ))}
                </div>
              )}
            </FieldArray>
          )}
          {device.value === 'mobile' && (
            <FieldArray name={`mainImage[1].imagesUrl`}>
              {arrayHelpers => (
                <div style={{display: 'flex'}}>
                  {!_isEmpty(
                    _get(formikProps.values, `mainImage[1].imagesUrl`)
                  ) &&
                    _get(formikProps.values, `mainImage[1].imagesUrl`)
                      .filter((_, index) => index === 1)
                      .map((s, index) => (
                        <div
                          key={`phonebanner${index}`}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <Field
                            name={`mainImage[1].imagesUrl[${index}]`}
                            scaleImage={true}
                            clearFormFields={[
                              `mainImage[1].imagesUrl[${index}].image`,
                            ]}
                            component={DeviceImage}
                            width={750}
                            height={996}
                            maxWidth={300}
                            maxHeight={(300 / 750) * 996}
                            values={formikProps.values}
                          />
                        </div>
                      ))}
                </div>
              )}
            </FieldArray>
          )}
          {device.value === 'padLandscape' && (
            <FieldArray name={`mainImage[2].imagesUrl`}>
              {arrayHelpers => (
                <div style={{display: 'flex'}}>
                  {!_isEmpty(
                    _get(formikProps.values, `mainImage[2].imagesUrl`)
                  ) &&
                    _get(formikProps.values, `mainImage[2].imagesUrl`)
                      .filter((_, index) => index === 1)
                      .map((s, index) => (
                        <div
                          key={`phonebanner${index}`}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <Field
                            name={`mainImage[2].imagesUrl[${index}]`}
                            scaleImage={true}
                            clearFormFields={[
                              `mainImage[2].imagesUrl[${index}].image`,
                            ]}
                            component={DeviceImage}
                            width={3840}
                            height={2880}
                            maxWidth={300}
                            maxHeight={(300 / 3840) * 2880}
                            values={formikProps.values}
                          />
                        </div>
                      ))}
                </div>
              )}
            </FieldArray>
          )}
        </div>
      </div>
    </>
  );
}
